import React from "react";
import Row from "../grid/Row";
import Col from "../grid/Col";
import { string, bool, func } from "prop-types";
import MdEdit from "react-icons/lib/md/edit";
import MdDelete from "react-icons/lib/md/delete";
import Button from "../button/Button.js";
import "./Checkbox.css";

class Checkbox extends React.Component {
  static PropTypes = {
    text: string,
    checked: bool,
    onCheckboxClick: func,
    onEditButtonClick: func
  };

  constructor(props) {
    super(props);
    this.state = {
      active: this.props.checked || false
    };

    this.onCheckBoxClick = this.onCheckBoxClick.bind(this);
    this.onEditButtonClick = this.onEditButtonClick.bind(this);
    this.onDeleteButtonClick = this.onDeleteButtonClick.bind(this);
  }

  onCheckBoxClick() {
    const { value, name } = this.props;
    this.setState({ active: !this.state.active });

    this.props.onCheckboxClick(value, name);
  }

  onEditButtonClick(e) {
    e.stopPropagation(); // Stop event propagation a.k.a make parent component ignore the click event
    this.props.onEditButtonClick(this.props.value);
  }

  onDeleteButtonClick(e) {
    e.stopPropagation(); // Stop event propagation a.k.a make parent component ignore the click event
    this.props.onDeleteButtonClick(this.props.value);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.checked) {
      this.setState({ active: true });
    }
  }

  render() {
    return (
      <div
        className={`checkbox ${this.state.active ? "active" : ""}`}
        onClick={this.onCheckBoxClick}
      >
        <Row _space-between _align-center>
          {this.props.text}
          <Col>
            <div className={"checkbox-status"} />
            {typeof this.props.onEditButtonClick === "function" && (
              <Button
                className="btn-blue btn-square"
                onClick={this.onEditButtonClick}
              >
                <MdEdit />
              </Button>
            )}
            {typeof this.props.onDeleteButtonClick === "function" && (
              <Button
                className="btn-red btn-square"
                onClick={this.onDeleteButtonClick}
              >
                <MdDelete />
              </Button>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/common/checkbox/Checkbox.js